import viewport from "./viewport";

export default function () {
    let ink, d, x, y;

    let link = document.querySelectorAll('.tap-link, .btn__text, .cart-btn, .pic-checkbox, .jq-number__spin, .main-tabs-links__item');

    Array.from(link).forEach(button => button.addEventListener('click', function(e){

        if(viewport().width < 980) {
            let currentBtn = this;

            if (currentBtn.getElementsByClassName('ink').length === 0) {
                ink = document.createElement('em');
                ink.classList.add('ink');
                currentBtn.append(ink);
            }
            else {
                ink = currentBtn.getElementsByClassName('ink')[0];
            }

            ink.classList.remove('animate');

            if (!ink.offsetHeight && !ink.offsetWidth) {
                d = Math.max(currentBtn.offsetWidth, currentBtn.offsetHeight);
                ink.style.height = d + 'px';
                ink.style.width = d + 'px';
            }
            x = e.clientX - currentBtn.getBoundingClientRect().left - ink.offsetWidth / 2;
            y = e.clientY - currentBtn.getBoundingClientRect().top - ink.offsetHeight / 2;

            ink.style.top = y + 'px';
            ink.style.left = x + 'px';

            ink.classList.add('animate');
        }

    }));

}
